export function readDiscoverySearch(search) {
  const params = new URLSearchParams(search);
  const result = {};
  for (const key of ["q", "location", "specialization", "interest", "city"]) result[key] = (params.get(key) || "").slice(0, 100);
  const latitude = params.get("latitude"), longitude = params.get("longitude");
  if (latitude && longitude && Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude)) && Math.abs(Number(latitude)) <= 90 && Math.abs(Number(longitude)) <= 180) {
    result.coords = { latitude: Number(latitude), longitude: Number(longitude) };
  }
  return result;
}

export function discoveryLink(category, search) {
  const params = new URLSearchParams();
  if (search.q) params.set("q", search.q);
  if (search.location) params.set(category === "pharmacies" ? "city" : "location", search.location);
  if (search.specialization && category !== "pharmacies") params.set(category === "doctors" ? "specialization" : "interest", search.specialization);
  for (const key of ["latitude", "longitude"]) if (search[key] != null) params.set(key, search[key]);
  const query = params.toString();
  return `/${category}${query ? `?${query}` : ""}`;
}
